import React, {useState} from 'react'
import {KTSVG, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../../../../../../_metronic/common/table/core/ListViewProvider'
import {useAuth} from '../../../../../auth'
import {reportStock} from '../../core/_requests'
import {useQuery} from 'react-query'
import {getStockCategories} from '../../../stock-categories/core/_requests'

export const StockListToolbar = () => {
  const {isSuperAdmin, isAdmin, isStockManager, currentUser} = useAuth()
  const {setItemIdForUpdate} = useListView()
  const [isSubmitting, setSubmitting] = useState(false)
  const [selectedCategoryId, setSelectedCategoryId] = useState('ALL')
  const {data: categoriesResponse} = useQuery(`${QUERIES.STOCK_CATEGORIES_LIST}-stock-report`, () => getStockCategories('', currentUser), {
    enabled: !!currentUser,
  })
  const categories = categoriesResponse?.data?.Items || []

  const [submitted, setSubmitted] = useState(false)

  const openStockModal = () => {
    setItemIdForUpdate(null)
  }

  const stockReport = async () => {
    try {
      setSubmitting(true)
      await reportStock(currentUser, selectedCategoryId)
      setSubmitted(true)
      setTimeout(() => {
        setSubmitted(false)
      }, 5000)
    } catch (ex: any) {
      console.error(ex)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      {(isSuperAdmin() || isAdmin() || isStockManager()) && (
        <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
          {/* begin::Add user */}
          <select className='form-select form-select-sm form-select-solid w-200px me-3' value={selectedCategoryId} onChange={(e) => setSelectedCategoryId(e.target.value)} disabled={isSubmitting || submitted}>
            <option value='ALL'>ALL</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id?.toString()}>
                {category.name}
              </option>
            ))}
          </select>
          <button type='button' className='btn btn-sm btn-primary' onClick={stockReport} disabled={isSubmitting || submitted}>
            {!isSubmitting && !submitted && 'Stock Report'}
            {!isSubmitting && submitted && 'Stock Report Requested'}
            {isSubmitting && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Stock Report Generating... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <button type='button' className='btn btn-sm btn-primary ms-3' onClick={openStockModal}>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Add New Stock Item
          </button>
          {/* end::Add user */}
        </div>
      )}
    </>
  )
}
